import { render, staticRenderFns } from "./Avantages.vue?vue&type=template&id=74570bac"
import script from "./Avantages.vue?vue&type=script&lang=js"
export * from "./Avantages.vue?vue&type=script&lang=js"
import style0 from "./Avantages.vue?vue&type=style&index=0&id=74570bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports